// extracted by mini-css-extract-plugin
export default {"button":"button_button__5YdW8","button_cancel":"button_button_cancel__mlq82","button_link":"button_button_link__7+Ec0"};